var React = require('react');

function RemoveIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.49695 2.96985L7.4668 5.9397L10.4366 2.96985L11.964 4.4972L8.99415 7.46705L11.964 10.4369L10.4366 11.9642L7.4668 8.9944L4.49695 11.9642L2.9696 10.4369L5.93945 7.46705L2.9696 4.4972L4.49695 2.96985Z","fill":"#003A1B"}));
}

RemoveIcon.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = RemoveIcon;

RemoveIcon.default = RemoveIcon;
